export const VISA_ROUTES = [
  ["14days-single", "14 Days Visa"], ["14days-multiple", "14 Days Multiple Entry"],
  ["30days-single", "30 Days Visa"], ["30days-multiple", "30 Days Multiple Entry"],
  ["60days-single", "60 Days Visa"], ["60days-multiple", "60 Days Multiple Entry"],
  ["90days-single", "90 Days Visa"], ["96hours-transit", "96 Hours Transit"],
] as const;
